import React from 'react';
import PropTypes from 'prop-types';

import {screenSizeSmaller} from 'views/components';
import {BigCalendar, EventWrapper} from 'views/module';
import EventTile from './EventTile';
import MonthlyEventTile from './MonthlyEventTile';

import moment from 'moment';

const CalendarDisplay = (props) => {
  const [rangeView, setRangeView] = React.useState();
  const [view, setView] = React.useState(screenSizeSmaller('md') ? 'month' : 'week' );

  const events = props.events;
  const loadMonthlyEvents = props.loadMonthlyEvents;
  const openEvent = props.openEvent;
  const reload = props.reload;
  const viewingTimezone = props.viewingTimezone;

  React.useEffect(() => {
    const monthsToCheck = [];
    if (rangeView) {
      let start = null;
      let end = null;
      if (view === 'month') {
        start = moment(rangeView.start).date(1);
        end = moment(rangeView.end).date(1);
      } else {
        start = moment(rangeView[0]).date(1);
        end = moment(rangeView[rangeView.length - 1]).date(1);
      }
      while (start.isSameOrBefore(end)) {
        monthsToCheck.push({year: start.year(), month: start.month()});
        start.add(1, 'M');
      }
    } else {
      const now = moment();
      monthsToCheck.push({year: now.year(), month: now.month()});

      const lastMonth = moment().subtract(1, 'M');
      monthsToCheck.push({year: lastMonth.year(), month: lastMonth.month()});

      const nextMonth = moment().add(1, 'M');
      monthsToCheck.push({year: nextMonth.year(), month: nextMonth.month()});
    }
    loadMonthlyEvents(monthsToCheck);
  }, [rangeView, view, reload]);


  const onRangeChange = (rangeView, view) => {
    setRangeView(rangeView);
    if (view) {
      setView(view);
    }
  };
  const onViewChange = (view) => {
    setView(view);
  };

  const onSelectEvent = (scheduleEvent, e) => {
    openEvent(scheduleEvent.event.eventRn, scheduleEvent.event);
  };

  const eventsToDisplay = React.useCallback(() => {
    return events
        .map((event, index) => {
          const newEvent = {};
          newEvent.index = index;
          newEvent.start = moment(event.eventData.startTime).toDate();
          newEvent.end = moment(event.eventData.endTime).toDate();
          newEvent.title = event.info.title;
          newEvent.event = event;
          return newEvent;
        });
  }, [events]);

  const tooltipAccessor = (event) => {
    if (view === 'month') {
      const startTime = moment(event.start).format('h:mm:ssa'); ;
      const endTime = moment(event.end).format('h:mm:ssa'); ;
      return (`${startTime}-${endTime}: ${event.title}`);
    } else {
      return `${event.title}`;
    }
  };

  return (
    <BigCalendar
      events={eventsToDisplay()}
      showMultiDayTimes={true}
      defaultView={view}
      views={['month', 'week', 'day']}
      onRangeChange={onRangeChange}
      onView={onViewChange}
      onSelectEvent={onSelectEvent}
      timezone={viewingTimezone}
      tooltipAccessor={tooltipAccessor}
      components={{
        event: view === 'month' ? MonthlyEventTile : EventTile,
        eventWrapper: EventWrapper,
      }}
    />
  );
};

CalendarDisplay.propTypes = {
  events: PropTypes.array.isRequired,
  loadMonthlyEvents: PropTypes.func.isRequired,
  openEvent: PropTypes.func.isRequired,
  reload: PropTypes.number.isRequired,
  viewingTimezone: PropTypes.string.isRequired,
};

export default React.memo(CalendarDisplay);
